// @ts-nocheck







import CommonApi from '../commonApi';
import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { downloadRequestWithToken, fetchRequest } from './index';

export const convertDataToServer = (
inspectionGibddCalculation) => (
{
  ...inspectionGibddCalculation,
  sum: convertFromRubToKop(inspectionGibddCalculation.sum),
  months: inspectionGibddCalculation.months.map(convertDataToServerMonth)
});

export const convertDataFromServer = (
inspectionGibddCalculation) => (
{
  ...inspectionGibddCalculation,
  sum: convertFromKopToRub(inspectionGibddCalculation.sum),
  months: inspectionGibddCalculation.months.map(convertDataFromServerMonth)
});

export const convertDataToServerMonth = (
inspectionGibddCalculationMonth) => (
{
  ...inspectionGibddCalculationMonth,
  cost: convertFromRubToKop(inspectionGibddCalculationMonth.cost)
});

export const convertDataFromServerMonth = (
inspectionGibddCalculationMonth) => (
{
  ...inspectionGibddCalculationMonth,
  cost: convertFromKopToRub(inspectionGibddCalculationMonth.cost)
});

const basedUrl = 'inspectionGibddCalculation';
const inspectionGibddCalculation = new CommonApi(
  basedUrl,
  'расчет потребности в ТО ГИБДД',
  convertDataToServer,
  convertDataFromServer
);

const calculate = async (vehiclePlanId) => {
  const updated = await fetchRequest.put(
    `/${basedUrl}/calculate/${vehiclePlanId}`
  );
  if (updated) return updated;
  throw new Error(`Не удалось произвести расчет`);
};

const changeStatus = async (
vehiclePlanId,
status) =>
{
  const updated = await fetchRequest.put(`/${basedUrl}/changeStatus`, {
    vehiclePlanId,
    status
  });
  if (updated) return updated;
  throw new Error(`Не удалось сменить статус`);
};

const print = async (vehiclePlanId, filter) => {
  const printed = await downloadRequestWithToken(`/${basedUrl}/print`, {
    ...filter,
    vehiclePlanId
  });
  if (printed) return printed;
  throw new Error('Не удалось загрузить файл');
};

export default {
  ...inspectionGibddCalculation,
  calculate,
  changeStatus,
  print
};
